var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _path16, _path17;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCampingSquirrelContrast = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 86,
    viewBox: "0 0 85 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.5,
    cy: 42.4826,
    rx: 42.5,
    ry: 42.4826,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.8069 53.567L31.8152 53.6011L31.8281 53.6337C35.0309 61.713 35.4615 70.8612 34.7058 76.0073C31.6491 76.1772 30.6551 76.4334 29.8077 76.6928C29.7604 76.7073 29.7141 76.7216 29.6683 76.7358C29.3056 76.8478 28.9765 76.9494 28.4694 77.0418C27.8981 77.1458 27.0935 77.2388 25.7825 77.3053C25.7652 77.2938 25.7281 77.2647 25.6697 77.1966C25.5449 77.0511 25.4014 76.8196 25.2202 76.4924C25.1413 76.3499 25.0571 76.1924 24.9669 76.0235C24.66 75.4496 24.2834 74.7449 23.8084 74.055C23.1874 73.153 22.3737 72.2351 21.2545 71.5683C20.129 70.8977 18.7212 70.4971 16.9419 70.5927C12.7807 70.8162 9.6582 68.4664 8.68498 64.7122C8.45515 63.8256 8.49495 62.484 8.86928 60.9178C9.24084 59.3631 9.93152 57.6322 10.9542 55.9839C12.9999 52.6866 16.3429 49.7635 21.0717 49.1787C28.7486 48.2293 31.3977 51.8744 31.8069 53.567ZM25.7941 77.312C25.7941 77.312 25.7937 77.3118 25.7927 77.3113L25.7941 77.312Z",
    fill: "white",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.634 61.1648C37.0671 60.5305 24.5253 77.023 22.2778 79.7982C33.3831 88.1238 58.37 88.5202 69.8719 75.0407C67.3335 70.9176 58.0614 59.8433 55.1529 59.9754C57.3739 53.6321 63.614 49.4033 66.6548 47.6853L36.5118 52.4428C43.4923 54.6629 46.1629 58.6539 45.634 61.1648Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7525 19.9334C34.6081 20.2506 36.6441 22.18 37.3051 23.1051L34.5288 27.8625C32.5457 28.3911 28.5795 28.7347 28.5795 25.8802C28.5795 23.0258 27.5219 21.2549 26.9931 20.7263C27.3897 20.3299 28.8968 19.6162 31.7525 19.9334Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2751 12.7971C61.1022 13.4314 59.2513 16.7617 58.7225 18.3475L61.4988 21.1227C62.4242 20.5941 64.4338 19.0611 65.0683 17.1581C65.7029 15.2551 64.8039 13.4579 64.2751 12.7971Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7726 21.3379C31.4869 24.8879 30.1655 35.7262 30.1655 40.7016C38.094 45.5425 57.6952 41.3739 67.3306 38.6845C67.3306 36.533 68.5694 33.0368 68.1565 28.1959C67.8767 24.916 62.9258 19.8587 60.7234 17.7072C56.181 15.6902 43.3797 16.9004 36.7726 21.3379Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.098 23.5013C33.6559 26.9901 32.0165 37.3773 31.7521 42.1347C41.9055 43.7205 48.41 40.1525 50.3931 38.1702C47.2202 24.5321 40.8743 22.7084 38.098 23.5013Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5153 27.466C59.5153 30.3205 62.9527 34.4701 64.6714 36.1881C66.2578 35.3952 70.224 34.6022 68.6375 29.0519C67.3684 24.6116 63.3493 20.3298 61.4984 18.744C59.912 19.5369 59.5153 23.8979 59.5153 27.466Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5153 27.466C59.5153 30.3205 62.9527 34.4701 64.6714 36.1881C66.2578 35.3952 70.224 34.6022 68.6375 29.0519C67.3684 24.6116 63.3493 20.3298 61.4984 18.744C59.912 19.5369 59.5153 23.8979 59.5153 27.466Z",
    stroke: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0807 39.7561C41.6672 39.7561 46.8232 38.9632 49.203 38.5667C51.7149 38.3024 57.294 37.5359 59.515 36.5844C62.2913 35.3951 69.0338 33.8093 70.6203 34.9986C72.2068 36.188 73 37.3774 73 40.1525C73 42.9277 69.8271 46.0994 67.0507 47.6852C64.2744 49.271 61.4981 49.271 60.3082 49.271C59.3564 49.271 58.0607 50.3282 57.5319 50.8568C51.186 54.8214 49.9962 54.4249 40.874 53.632C31.7518 52.8391 28.5788 48.0817 27.7856 45.3065C26.9924 42.5313 28.1822 40.1525 30.1653 39.3596C32.1484 38.5667 38.0977 39.7561 40.0807 39.7561Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3197 51.5417C61.957 49.4657 62.0669 45.1984 61.7922 43.3242C60.8032 44.3622 56.1603 44.9101 53.9625 45.0542C53.9625 45.9192 56.023 54.1367 59.3197 51.5417Z",
    fill: "#F9F7F7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0132 38.9629C48.3305 37.3771 50.9217 36.5842 51.9793 36.5842C55.0201 36.1877 61.025 34.919 62.2942 34.6018C63.8807 34.2054 63.0991 45.9654 59.1214 46.4956C53.1722 47.2885 47.6166 40.9452 48.0132 38.9629Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0132 38.9629C48.3305 37.3771 50.9217 36.5842 51.9793 36.5842C55.0201 36.1877 61.025 34.919 62.2942 34.6018C63.8807 34.2054 63.0991 45.9654 59.1214 46.4956C53.1722 47.2885 47.6166 40.9452 48.0132 38.9629Z",
    stroke: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1187 39.796C59.7533 39.4788 61.234 36.4922 61.895 35.0385C57.4529 33.7699 53.1695 35.5671 51.583 36.6243C53.6983 37.6816 58.1668 39.796 59.1187 39.796Z",
    fill: "#1E1E1E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9441 32.9349C46.4215 31.5418 45.5803 30.765 44.5305 30.4022C43.521 30.0534 42.3713 30.1078 41.2629 30.2351C39.6056 30.4254 38.1891 31.1779 37.2432 32.3904C36.2969 33.6034 35.853 35.236 36.0636 37.1303C36.252 38.8256 37.4995 39.8074 38.9467 40.2118C40.3832 40.6133 42.1032 40.4831 43.4918 39.9168C46.2482 38.7928 48.0122 35.7819 46.9441 32.9349Z",
    fill: "white",
    stroke: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5311 26.5897L64.2802 26.6632L64.1974 26.9113C63.5555 28.8362 63.8479 30.7048 64.5219 32.1633C65.1844 33.597 66.2589 34.7205 67.285 35.0747L67.3642 35.1021H67.4481C68.0187 35.1021 68.5177 34.8171 68.911 34.4297C69.3058 34.0407 69.6299 33.5162 69.8664 32.9425C70.3352 31.8051 70.5076 30.3535 70.0852 29.1504C69.6476 27.9039 68.6004 27.1583 67.539 26.7802C66.4858 26.4049 65.3267 26.3564 64.5311 26.5897Z",
    fill: "white",
    stroke: "black"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.6681,
    cy: 35.7915,
    rx: 1.18985,
    ry: 1.18937,
    fill: "#C4C4C4"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.0512,
    cy: 30.2412,
    rx: 1.98309,
    ry: 1.98228,
    fill: "#2E1B00"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.0645,
    cy: 35.3952,
    rx: 3.17294,
    ry: 3.17164,
    fill: "#2E1B00"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.8572,
    cy: 34.6021,
    rx: 0.793235,
    ry: 0.792911,
    fill: "white"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.8443,
    cy: 29.4482,
    rx: 0.396618,
    ry: 0.396456,
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7225 48.4781V52.4427",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7122 85.7449C41.7388 79.8318 46.6229 68.3143 50.8344 67.1115C55.8479 65.6796 61.6203 72.2602 64 79C64 79 61.5431 82.1768 54.404 84.1591C47.2648 86.1414 41.7122 85.7449 41.7122 85.7449Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCampingSquirrelContrast);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/CampingSquirrel-contrast.edc51f6ff58466513b751d3215dd4a22.svg";